<template>
    <!--Client Waiting List Page-->
    <div class="client-step4">
        <!--Step Four-->
        <div class="client-step4-wrap section-wrap">
            <!--Subtitle-->
            <h5>{{ $t("waitingList.title") }} - {{ currentWaitingListStylist.first_name }}, {{
                currentWaitingListStylist.last_name }}</h5>
            <div class="steps">
                <p class="highlight-text">{{ $t("waitingListClient.stepOne") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $t("waitingListClient.stepTwo") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $t("waitingListClient.stepThree") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $t("waitingListClient.stepFour") }}</p>
            </div>
            <div class="client-step4-wrap" v-if="!loading">
                <p class="section-wrap">
                    {{ $t("waitingListClient.stepFourParagraph") }}
                </p>
                <div class="next-btn">
                    <button type="button" class="primary-btn extra-small mobile" 
                        @click="handleSaveClientWaitlistSettings">
                        {{ $t("general.continue") }}
                    </button>
                    <button type="button" class="secondary-btn small mobile" @click="changeSection('client-step3')">
                        {{ $t("general.goBack") }}
                    </button>
                </div>
            </div>
            <main-loader v-if="loading"></main-loader>
        </div>
    </div>
</template>

<script>
import store from "../../../../../services/vuex";
import api from "../../../../../services/apiEndpoints";
import MainLoader from "../../../general-components/MainLoader.vue";

export default {
    data() {
        return {
            notificationTime: '',
            loading: false,
            completed: 0,
        };
    },
    computed: {
        currentWaitingListStylist: {
            get: function () {
                return this.$store.state.currentWaitingListStylist;
            },
            set: function (value) {
                this.$store.commit("setCurrentWaitingListStylist", value);
            },
        },
    },
    mounted() {
        this.getClientWaitlistSettings(this.currentWaitingListStylist.id);
    },
    components: { MainLoader },
    methods: {
        changeSection(section) {
            this.$emit('change-section', section);
        },
        handleSaveClientWaitlistSettings() {
            this.saveClientWaitlistSettings();
            this.changeSection('client-final-step');
        },
        saveClientWaitlistSettings() {
            this.notificationTime = 'immediately';
            this.completed = 1;

            let data = {
                stylist_id: this.currentWaitingListStylist.id,
                send_time: this.notificationTime,
                completed: this.completed,
            };

            this.$http.post(api.actions.save_client_waitlist_settings, data).then((response) => {

                if (response.data.error == true) {
                    return;
                }

                this.getClientWaitlistSettings(this.currentWaitingListStylist.id);
            });
            return;
        },
        getClientWaitlistSettings(stylistId) {
            this.loading = true;

            this.$http.get(api.actions.get_client_waitlist_settings + "/" + stylistId).then(
                function (response) {
                    if (response.data.error == true) {
                        return;
                    }

                    this.notificationTime = response.data.settings.send_time;
                    this.loading = false;

                }.bind(this)
            );
        },
    },
};
</script>
